var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-welcome-container"},[_c('div',{staticClass:"fullscreen-welcome-message",class:{
      'message-enter': _vm.welcomeAnimationState === 'entering',
      'message-leave': _vm.welcomeAnimationState === 'leaving'
    },style:(_vm.welcomeMessageStyle)},[_c('div',{staticClass:"welcome-text-content"},[_vm._v(_vm._s(_vm.welcomeMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }